import { MESSAGES_EVENTS } from '../../../config/config';
import socket from '../../socket';

export default async ({ commit }) => {
  socket.on(MESSAGES_EVENTS.NEW_MONITOR_MESSAGE, ({ from }) => {
    commit('unreadMonitorMessages', from);
  });
  socket.on(MESSAGES_EVENTS.READ_MONITOR, ({ monitors }) => {
    commit('unreadMonitorMessages', monitors);
  });
};
